import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './AzelaicAcidPeel.css';

function AzelaicAcidPeel() {
  const { t } = useTranslation();

  return (
    <div className="azelaic-acid-peel-page">
      {/* Hero Section */}
      <section className="azelaic-acid-peel-hero">
        <div className="container">
          <h1>Azelaic Acid Peel — Calm, Clear & Balanced Skin</h1>
          <p className="hero-subtitle">
            Designed for sensitive, acne-prone, and rosacea-affected skin, the Azelaic Acid Peel gently reduces 
            inflammation, unclogs pores, and brightens uneven tone — all without aggressive exfoliation.
          </p>
          <p className="hero-note">
            A perfect treatment for clients seeking clearer, calmer skin with a healthy, natural glow.
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="azelaic-acid-peel-content">
        <div className="container">
          <div className="content-wrapper">
            {/* What's Included */}
            <div className="content-section">
              <h2>What's Included</h2>
              <ul className="included-list">
                <li>Gentle double cleanse</li>
                <li>Azelaic peel application</li>
                <li>Soothing mask tailored to your skin needs</li>
                <li>Hydrating moisturiser and SPF protection</li>
              </ul>
            </div>

            {/* Benefits */}
            <div className="content-section">
              <h2>Benefits of Azelaic Acid</h2>
              <ul className="benefits-list">
                <li>Reduces acne and breakouts</li>
                <li>Calms redness and irritation (rosacea-friendly)</li>
                <li>Brightens pigmentation and post-inflammatory marks</li>
                <li>Controls excess oil</li>
                <li>Smooths rough or bumpy texture</li>
                <li>Antibacterial and anti-inflammatory properties</li>
                <li>Suitable for sensitive skin types</li>
              </ul>
              <div className="highlight-note">
                <p>
                  <strong>Ideal for treating active acne, redness, and post-acne scarring.</strong>
                </p>
              </div>
            </div>

            {/* Sessions Needed */}
            <div className="content-section">
              <h2>How Many Sessions Do I Need?</h2>
              <p>
                <strong>Course:</strong> 4–6 treatments every 1–2 weeks
              </p>
              <p>
                <strong>Maintenance:</strong> Monthly maintenance facials recommended for lasting results
              </p>
            </div>

            {/* Not Suitable */}
            <div className="content-section">
              <h2>Not Suitable If You Are:</h2>
              <ul className="not-suitable-list">
                <li>Taking prescription acne medication (isotretinoin)</li>
                <li>Experiencing active cold sores or skin infection</li>
                <li>Recently used retinol/AHA/BHA (within the last 7 days)</li>
                <li>Diagnosed with eczema or psoriasis in the treatment area</li>
                <li>Recently had fillers or Botox (within 2 weeks)</li>
              </ul>
            </div>

            {/* Managing Side Effects */}
            <div className="content-section">
              <h2>Managing Side Effects</h2>
              <p>
                Mild and short-term reactions may include:
              </p>
              <ul className="side-effects-list">
                <li>Light redness</li>
                <li>Mild dryness or flaking</li>
                <li>Temporary tingling</li>
                <li>Slight sensitivity</li>
              </ul>
              <div className="side-effects-note">
                <p>
                  <em>These usually settle within a few hours to a couple of days.</em>
                </p>
              </div>
            </div>

            {/* Post-Treatment Care */}
            <div className="content-section">
              <h2>Post-Treatment Care</h2>
              <h3>For the first 24–48 hours:</h3>
              <ul className="aftercare-list">
                <li>Avoid direct sunlight</li>
                <li>Use SPF 30+ daily</li>
                <li>Avoid makeup for 24 hours</li>
                <li>Cleanse gently</li>
                <li>Keep skin well moisturised</li>
                <li>Avoid sweating, saunas, and steam rooms</li>
                <li>Avoid swimming or chlorinated water for 2–3 days</li>
              </ul>
            </div>

            {/* CTA Section */}
            <div className="cta-section">
              <h2>{t('services.cta.title')}</h2>
              <p>{t('services.cta.description')}</p>
              <div className="cta-buttons">
                <a href="https://widget.treatwell.co.uk/place/beauty-lounge-green-canning-town/" target="_blank" rel="noopener noreferrer" className="cta-button primary">{t('services.cta.button')}</a>
                <Link to="/services" className="cta-button secondary">Back to Services</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AzelaicAcidPeel;

